import { RefBool, RefString } from "@tblabs/truffle";
import { StepRawData } from "./StepRawData";


export class StepData
{
    public State = new RefString();
    public CreatedAt = new Date(0);
    public AssignedAgentId = new RefString();
    public VisibleForCustomer = new RefBool(true);
    public SearchBy: string = "";
    // TODO:
    // public Notes = new RefString();
    // public MessageToCustomer = new RefString();

    constructor(raw: Partial<StepRawData>)
    {
        this.State.value = raw.State || "";
        this.CreatedAt = this.GetDate(raw.CreatedAt);
        this.AssignedAgentId.value = raw.AssignedAgentId || "";
        this.VisibleForCustomer.value = raw.VisibleForCustomer ?? true;
    }

    protected GetDate(rawDate?: Date): Date
    {
        return new Date(rawDate || 0);
    }

    protected GetString(rawString?: string): string
    {
        return rawString || "";
    }

    protected GetNumber(rawNumber?: number): number
    {
        return rawNumber || 0;
    }
}
